import { gql } from '@apollo/client'

const QUERY_MERCHANT_PARTNERS = gql`
  query getMerchantPartners($merchantId: uuid!) {
    partners_merchants(where: { merchant_id: { _eq: $merchantId } }) {
      partner {
        name
      }
    }
  }
`

const QUERY_STREAM_SSO_REDIRECT = gql`
  query generateStreamSso {
    generateStreamSso {
      redirect_url
    }
  }
`

export { QUERY_MERCHANT_PARTNERS, QUERY_STREAM_SSO_REDIRECT }
